import apisauce from "apisauce";

const create = (baseURL = process.env.REACT_APP_ISDEV === 'true' ? "https://devapigateway.desapedia.co.id/v1/cmslandingapi/" : "https://apigateway.desapedia.co.id/v1/cmslandingapi/") => {
  const api = apisauce.create({
    baseURL,
    headers: {
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    timeout: 30000,
  });

  const getContentCmsData = () => api.get(`content`);

  return {
    getContentCmsData,
  };
};

export default {
  create,
};
